import { createSelector } from "reselect";

import {
  TContractor,
  TDBAccount,
  TDBContractor,
  TEmitent,
  TSPVMessageKeys,
} from "@app/types/insider";

import { schema } from "../schema";
import {
  defaultEmptyContractor,
  tContractorFormData,
  tContractorFromDbContractorAsCustomer,
  tContractorFromDbContractorAsSupplier,
  tDbContractorToContractor,
} from "./uiSpvMainContractor.sel";

import type { TIssuerAsContractor } from "@app/types/insider";
/* 
export type TSPVMessageKeys = {
  FMK_ID: number;
  FXM_ID: number;
  CFF_ID: number;
  CFFTMP_ID: number;
  CLI_FF_ID: number;
  FZ_F_ID: number;
  PARSE_ATTEMPTS: number;
  UPDATED: string;
};

*/
const selectContractorsIdx = createSelector(
  schema.SPVMessageKeys.selectTableAsList,
  (spvKeys) => {
    return spvKeys.reduce((acc, item: TSPVMessageKeys) => {
      // is a client?
      acc[`${item.CFF_ID}::cli`] =
        acc[`${item.CFF_ID}::cli`] === true ? true : Boolean(item.CLI_FF_ID);
      // is a supplier?
      acc[`${item.CFF_ID}::sup`] =
        acc[`${item.CFF_ID}::sup`] === true ? true : Boolean(item.FZ_F_ID);
      return acc;
    }, {});
  }
);

export const selectContractorsGrid = createSelector(
  schema.contractors_cff.selectTableAsList,
  selectContractorsIdx,
  (contactlist, ctctorTypeIdx) => {
    return contactlist.map((item: TDBContractor) => {
      const { CFF_ID } = item;
      return {
        CffId: CFF_ID,
        ClientName: item.DENUMIRE_F,
        TaxCode: item.CIF,
        __isClient: ctctorTypeIdx[`${CFF_ID}::cli`],
        __isSupplier: ctctorTypeIdx[`${CFF_ID}::sup`],
      };
    });
  }
);
const selectGridDataIdx = createSelector(
  selectContractorsGrid,
  (contractors) => {
    return contractors.reduce((acc, item) => {
      acc[item.CffId] = item;
      return acc;
    }, {});
  }
);
export const selectCurrentEditingContrator = createSelector(
  schema.uiContractorsEditing.select,
  schema.contractors_cff.selectTable,
  selectGridDataIdx,
  (editing, contractorsCFF, gridDataIdx): TContractor => {
    const dbContractor = contractorsCFF[editing.mainCffId];
    if (!dbContractor) {
      return tContractorFormData(
        tContractorFromDbContractorAsCustomer(defaultEmptyContractor),
        -1,
        -1
      );
    }
    return tContractorFormData(
      gridDataIdx[editing.mainCffId].__isSupplier
        ? tContractorFromDbContractorAsSupplier(dbContractor)
        : tContractorFromDbContractorAsCustomer(dbContractor),
      -1, //spvMessageId //
      -1 //trigger for render //
    );
  }
);

export const temporaryContractorDataLookup = createSelector(
  schema.contractors_temp.selectTableAsList,
  (contactList) => {
    return Object.values(
      contactList.reduce((acc, item) => {
        if (item.CIF && item.DENUMIRE_F && !item.C_ID) {
          acc[item.CIF] = { text: item.DENUMIRE_F, value: item.CIF };
        }
        return acc;
      }, {})
    );
  }
);
